import { Entity } from '@nx-smartmonkey/shared/domain';

export interface PlansCalendarProps {
  date: string;
  value: number;
}

export interface PlansCalendarDTO {
  date: string;
  value: number;
}

export class PlansCalendar extends Entity<PlansCalendarProps> {
  get date(): string {
    return this.props.date;
  }
  get value(): number {
    return this.props.value;
  }
  set value(value: number) {
    this.props.value = value;
  }
  static create(data: PlansCalendarDTO): PlansCalendar {
    const { date, value } = data;
    return new PlansCalendar({ date, value });
  }
}
